<kendo-splitter orientation="horizontal" [style.height]="'100%'">
  <kendo-splitter-pane [collapsible]="true" size="50%">
    <div class="pane-content" style="height:100%">
      <app-project-scoping-items [projectId]="projectTab().ProjectId"></app-project-scoping-items>
    </div>
  </kendo-splitter-pane>
  <kendo-splitter-pane>
    <kendo-splitter orientation="vertical">
      <kendo-splitter-pane [resizable]="false" size="5%">
        <div class="pane-content" style="height:100%">
          <app-project-scoping-capital [projectId]="projectTab().ProjectId" [scenarioId]="projectTab().ScenarioId"></app-project-scoping-capital>
        </div>
      </kendo-splitter-pane>
      <kendo-splitter-pane [collapsible]="true" size="45%">
        <div class="pane-content" style="height:100%">
          <app-project-scoping-capacities [projectId]="projectTab().ProjectId"></app-project-scoping-capacities>
        </div>
      </kendo-splitter-pane>
      <kendo-splitter-pane [collapsible]="true">
        <div class="pane-content" style="height:100%">
          <app-project-scoping-chart [projectId]="projectTab().ProjectId" [scenarioId]="projectTab().ScenarioId"></app-project-scoping-chart>
        </div>
      </kendo-splitter-pane>
    </kendo-splitter>
  </kendo-splitter-pane>
</kendo-splitter>